/**
 * UI text constants for command buttons
 */

/** Text shown on the button to start a pull request */
export const START_PULL_REQUEST_BUTTON_TEXT = 'Start a pull request'
